export default __webpack_public_path__ + "static/media/DSC03548.769f0dd0.JPG";